export default {
      id: "map-pin-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#map-pin-usage",
      toString: function () {
        return this.url;
      }
    }